import { FiSearch } from "react-icons/fi"
import { CustomContainer, FlexRow, Input } from "src/style"

export const SearchInput:React.FC<any> = ({onChange}) => {
    
    function handleChange (e: React.ChangeEvent<HTMLInputElement>) {
        onChange(e)
    }

    return (
        <CustomContainer 
            width='43' radius='0.8' 
            borderColor='#BDBDBD' 
            leftPadding='1.5' rightPadding='1.5'
        >
            <FlexRow>
                <FiSearch style={{fontSize: '1.6rem', color: '#BDBDBD'}} />
                <Input 
                    height='4.4' leftPadding='1' placeholder='Search'
                    onChange={handleChange} 
                />
            </FlexRow>
        </CustomContainer>
    )
}